import {pathname} from "../../../common/others/Configuration";
import Backbone from "backbone";

export default Backbone.Model.extend({

  alertingLevel: { Optout: 'Optout', Optin: 'Optin', Limited: 'Limited' },
  alertingType: { Unknow: 'Unknow', Mail: 'Mail', Phone: 'Phone', UseMyPhoneNumber: 'UseMyPhoneNumber' },

  url: function() {
    // TODO move to account configuration
    return [pathname, '/myaccount/api/v1/alerting/'].join('');
  },

  sync: function (method, model, options) {
    options.emulateHTTP = true;
    options.url = [this.url(), this.get('id')].join('');
    model.attributes = {
      AlertingLevel: model.attributes.AlertingLevel
    };
    return Backbone.sync(method, model, options);
  }
});
